import { Component, Input, OnInit } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

const KEY = 'user'

@Component({
  selector: 'atyl-user-list',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/user',
  key: KEY,
})
export class UserListComponent implements OnInit {

  expanded: boolean = false;
  @Input() users: any[] = [];
   @Input() professionel: boolean=true;
 @StringableValues(KEY) strings: any

  constructor() { }

  ngOnInit() {
	//console.log("UserListComponent init",this.users);
  }

}